export default __webpack_public_path__ + "static/media/vahid_tad.289ae118.jpeg";